module.exports = __webpack_public_path__ + "static/media/Michael's Resume.49b92eef.pdf";